//@Core
import React, { useEffect } from "react";

//@Third Party
import { Fade } from "react-reveal";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Tab, Tabs, Typography } from "@mui/material";

//@Dev
// # Locale
import Dots from "../../../../Components/Loader/Dots";
import UseGetData from "../../../../HookAxios/getdata";
import { GET_REQUEST } from "../../../../HooksApi/useApi";
import { Section } from "./styledFileDetails";
import FileDetailsForm from "./fileDetailsForm";
import { FileComments } from "./fileComments";

//@Style
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
    sx: { fontSize: "1.1rem" },
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export function FileDetails() {
  //* @Initiate
  const nav = useNavigate();
  const { courseId, fileId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const zoomPluginInstance = zoomPlugin({ enableShortcuts: true });

  //* @Component State
  const [value, setValue] = React.useState(0);
  const token = useSelector((state) => state.Auth.userInfo.token);

  //* @Async
  const {
    isLoading: isFileLoading,
    data: fileData,
    isError: isFileError,
    error: fileError,
  } = GET_REQUEST({
    queryKey: `work_papers_file${fileId}`,
    request: () =>
      UseGetData(
        `work_papers/${courseId}/${fileId}`,
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      ),
    enabled: true,
  });

  //* @Handlers
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //* @Component LifeCycle
  useEffect(() => {
    if (isFileError) {
      if (fileError.response.status === 403) {
        nav(-1);
        enqueueSnackbar(fileError?.response?.data?.message, {
          variant: "error",
        });
      }
    }
  }, [isFileError, fileError]);

  if (isFileLoading) {
    return <Dots />;
  }

  if (isFileError) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="red" sx={{ fontSize: "1rem" }}>
          {fileError?.response?.data?.message}
        </Typography>
      </Box>
    );
  }

  return (
    <Section sx={{ display: "flex", flexDirection: "column", gap: "2.75rem" }}>
      <Typography
        sx={{ color: "#333333", fontSize: "1.5rem", fontWeight: "800" }}
      >
        {fileData?.data?.data?.at(0)?.work_paper_ids_question?.title}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: "divider", display: "block" }}>
        <Tabs
          scrollButtons
          value={value}
          allowScrollButtonsMobile
          onChange={handleChange}
          variant="scrollable"
          aria-label="lab API tabs example"
        >
          <Tab label={"الأسئلة"} {...a11yProps(0)} />
          <Tab label={"الأجوبة"} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <TabPanel value={value} index={0}>
          <Fade>
            <Box
              sx={(theme) => ({
                paddingInline: "1rem",
                border: "1px solid rgba(0, 0, 0, 0.3)",
                height: "700px",
                [theme.breakpoints.down("sm")]: {
                  width: "300px",
                  height: "300px",
                },
              })}
            >
              <Viewer
                fileUrl={
                  process.env.REACT_APP_BASE_URL +
                  fileData?.data?.data?.at(0)?.work_paper_ids_question?.question
                }
                plugins={[zoomPluginInstance]}
              />
            </Box>
          </Fade>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Fade>
            <Box sx={{ paddingInline: "1rem" }}>
              <div
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  height: "700px",
                }}
              >
                <Viewer
                  fileUrl={
                    process.env.REACT_APP_BASE_URL +
                    fileData?.data?.data?.at(0)?.work_paper_ids_answer?.answer
                  }
                />
              </div>
            </Box>
          </Fade>
        </TabPanel>
      </Worker>

      <Box sx={{ paddingInline: "1rem" }}>
        <Box sx={{ width: "95%" }}>
          <FileDetailsForm />
        </Box>

        <FileComments fileData={fileData} />
      </Box>
    </Section>
  );
}
